import {create} from 'zustand';

const useFormStore = create((set) => ({

    openPopUp: false,


    setOpenPopUp: (openPopUp = false) => set({ openPopUp }),
}));

export default useFormStore;